import type { FC } from 'react'
import { useForm } from 'react-hook-form'
import { Button, Input } from 'components/ui'
import { UserSignIn } from '..'
import type { SignInProps } from '.'
import s from './sign-in.module.css'

const SignIn: FC<SignInProps> = ({ pushToRecoveryRequest, onSubmit, pushToSingUp }) => {
  const {
    register,
    handleSubmit,
    formState: { touched, errors, isSubmitting },
  } = useForm({
    mode: 'onChange',
  })

  const handleFormSubmit = (data: UserSignIn) => {
    onSubmit(data)
  }

  return (
    <div className={s.root}>
      <h1 className={s.title}>Entrar na sua conta</h1>
      <form onSubmit={handleSubmit(handleFormSubmit)} className={s.form}>
        <Input
          type="text"
          name="email"
          placeholder="Seu email aqui"
          error={errors?.email?.message}
          touched={touched?.email}
          maxLength={56}
          disabled={isSubmitting}
          ref={register({
            required: {
              value: true,
              message: 'Informe seu e-mail',
            },
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: 'E-mail inválido',
            },
          })}
        />
        <Input
          type="password"
          name="password"
          placeholder="••••••••"
          error={errors?.password?.message}
          touched={touched?.password}
          maxLength={32}
          disabled={isSubmitting}
          ref={register({
            required: {
              value: true,
              message: 'Informe sua senha',
            },
            minLength: {
              value: 4,
              message: 'A senha contém no mínimo 4 (quatro) caracteres',
            },
          })}
        />
        <Button variant="primary" type="submit" loading={isSubmitting}>
          Entrar
        </Button>
        <button type="button" className={s.forgotPassword} onClick={pushToRecoveryRequest}>
          Esqueceu a senha?
        </button>
      </form>
      <p>
        Ainda não tem conta?{' '}
        <button className={s.signUp} type="button" onClick={pushToSingUp}>
          Clique aqui
        </button>{' '}
        para criar registrar.
      </p>
    </div>
  )
}

export default SignIn
